//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../utils/style.css'

export default {
  props: {
    size: {
      type: String,
      default: '1em'
    }
  }
}
